import CalendarEventItem from "../CalendarEventItem";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
// import locale from 'dayjs/locale/pl';
dayjs.extend(isBetween);

export default {
  name: "CalendarSingleDay",
  components: {
    CalendarEventItem
  },
  data() {
    return {};
  },

  props: {
    selectedDate: {
      type: String,
      default: ""
    },
    day: {
      type: Object,
      default: () => ({})
    },
    isToday: {
      type: Boolean,
      default: false
    },
    hour: {
      type: Number,
      default: 0
    },
    data: {
      type: Array,
      default: () => []
    },
    colorsForRecords: {
      type: Array,
      default: () => []
    }
  },

  methods: {},
  computed: {
    formatedHourName() {
      return this.hour < 11 ? `0${this.hour - 1}:00` : `${this.hour - 1}:00`;
    },
    formatedNextHourName() {
      return this.hour < 10 ? `0${this.hour}:00` : `${this.hour}:00`;
    },
    filteredDataToRender() {
      return this.filteredDataPerHour.reduce((acc, x) => {
        acc[x.call_stamp] = [...(acc[x.call_stamp] || []), x];
        return acc;
      }, {});
    },
    filteredDataPerHour() {
      return this.data.filter(item => {
        return dayjs(item.call_stamp).isBetween(
          dayjs(`${this.selectedDate} ${this.formatedHourName}`).subtract(1, "minute"),
          dayjs(`${this.selectedDate} ${this.formatedNextHourName}`)
        );
      });
    }
  }
};
